import { Component, Input, Signal } from '@angular/core';
import { RoadOccupationFormValue } from '../../forms/road-occupation.form';
import { CommonModule } from '@angular/common';
import { OccupationTypePipe } from '../../pipes/occupationType.pipe';
import {
  RoadOccupationStageTableComponent
} from '../road-occupation-stage-table/road-occupation-stage-table.component';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { Store } from '@ngrx/store';
import { selectRoadOccupationTypes } from '../../../../../../../store/selectors/application.selectors';
import {
  ApplicationAppEntityApplicationRead,
  RoadOccupationTypeAppEntityDictionaryRoadOccupationType
} from '../../../../../../../openapi';
import { ParcelsPreviewComponent } from '../../../components/parcels/parcels-preview/parcels-preview.component';
import {
  LocationDecisionsPreviewComponent
} from '../../../components/location-decisions/location-decisions-preview/location-decisions-preview.component';

@Component({
  selector: 'app-occupation-preview',
  standalone: true,
  imports: [
    LabelComponent,
    CommonModule,
    OccupationTypePipe,
    RoadOccupationStageTableComponent,
    ParcelsPreviewComponent,
    LocationDecisionsPreviewComponent
  ],
  templateUrl: './occupation-preview.component.html'
})
export class OccupationPreviewComponent {

  @Input()
  public occupation: RoadOccupationFormValue | undefined;

  @Input()
  public application: ApplicationAppEntityApplicationRead | undefined;

  public roadOccupationTypes: Signal<RoadOccupationTypeAppEntityDictionaryRoadOccupationType[]> = this.store$.selectSignal(selectRoadOccupationTypes);

  constructor(private store$: Store) {
  }

  public get showLocationDecisions(): boolean {
    return [
      '/zajecie-pasa-prowadzenie-robot'
    ].includes(this.application?.service?.url || '')
  }
}
